import React from 'react';
import './spinner.css'; // Import the spinner styles

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="spinner">
                <img src="./tools.gif" alt="spinner"/>
            </div>
        </div>
    );
};

export default Spinner;
